import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformUnit'
})
export class TransformUnitPipe implements PipeTransform {

  transform(value: string): string {
    return value && value.includes('Kilograms') ? value.replace('Kilograms', 'Kgs') : value;
  }

}
